var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"background-color":"secondary","closed":"","header-prefix-icon":"history","no-margin-top":"","title":"Antecedentes","type":"box"}},[_c('BoxPaciente',{attrs:{"item":_vm.item}}),_c('BoxFamiliar',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }